/**
 * Get API base URL based on environment
 * Development: Uses proxy (empty string) to avoid CORS
 * Production: Uses VITE_API_URL or fallback to current origin
 *
 * @returns {string} Base URL for API requests
 */
export function getApiBaseUrl(): string {
  const isDevelopment = !import.meta.env.MODE || import.meta.env.MODE === "development";

  if (isDevelopment) {
    return (import.meta.env.VITE_API_URL as string) || ""; // Use VITE_API_URL if available, otherwise empty string for proxy
  }

  return (import.meta.env.VITE_API_URL as string) || `${window.location.protocol}//${window.location.host}`;
}
